import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "css/edit-category.css";
import { toast } from "react-toastify";
import { updateCategory, uploadCategoryImage } from "../api/categoriesApi";

export default function EditCategoryModal({
  show,
  handleClose,
  category,
  onSaved,
}) {
  const [cat, setCat] = useState(category);
  const [image, setImage] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setCat(category);
      setImage(null);
    }
  }, [show, category]);

  const handleUpload = (file) => {
    if (!file) return;

    if (file.size > 500 * 1024) {
      toast.error("Зураг 500KB-аас их байж болохгүй");
      return;
    }

    const url = URL.createObjectURL(file);
    setImage({ file, url });
  };

  const openFileDialog = () => {
    document.getElementById("edit-image-input").click();
  };

  const updateField = (field, value) => {
    setCat((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      const body = {
        name: cat.name,
        rank: cat.rank,
      };

      const res = await updateCategory(cat.id, body);

      if (!res.success) {
        toast.error(res.message || "Алдаа гарлаа");
        return;
      }

      // ⭐ Шинэ зураг сонгосон бол UPLOAD хийнэ. Өмнө нь зураг сонгоод хадгалахад
      //    зөвхөн нэр/эрэмбэ илгээгдэж, зураг огт орохгүй байв.
      if (image?.file) {
        const up = await uploadCategoryImage(image.file, cat.id);
        if (!up?.success) {
          toast.error("Нэр хадгалагдсан ч зураг оруулахад алдаа гарлаа");
        }
      }

      toast.success("Ангилал амжилттай шинэчлэгдлээ");
      onSaved?.(); // modal хаагаад жагсаалтыг refetch (reload оронд)
    } catch (err) {
      console.error(err);
      toast.error("Серверийн алдаа");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Ангилал засах</Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 pt-3 pb-4">
        {/* IMAGE UPLOAD */}
        <div className="upload-area">
          {image || cat.image ? (
            <div className="image-wrapper" onClick={openFileDialog}>
              <img src={image ? image.url : cat.image} alt="category" />

              <div className="edit-btn">
                <i className="ri-pencil-fill"></i>
              </div>

              <input
                id="edit-image-input"
                type="file"
                accept="image/jpeg"
                style={{ display: "none" }}
                onChange={(e) => handleUpload(e.target.files[0])}
              />
            </div>
          ) : (
            <div>
              <div
                className="upload-box"
                onClick={openFileDialog}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <i className="uil uil-image" style={{ fontSize: 28 }}></i>
                <div>Зураг нэмэх</div>
              </div>

              <input
                id="edit-image-input"
                type="file"
                accept="image/jpeg"
                style={{ display: "none" }}
                onChange={(e) => handleUpload(e.target.files[0])}
              />
            </div>
          )}
        </div>

        {/* FORM FIELDS */}
        <div className="form-column-layout">
          <Form.Group className="my-3">
            <Form.Label>Ангиллын нэр</Form.Label>
            <Form.Control
              type="text"
              value={cat?.name || ""}
              onChange={(e) => updateField("name", e.target.value)}
              placeholder="Жишээ: Гурил"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Эрэмбэ</Form.Label>
            <Form.Control
              type="number"
              value={cat?.rank || ""}
              onChange={(e) => updateField("rank", e.target.value)}
              placeholder="Жишээ: 1"
            />
          </Form.Group>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={saving}>
          Хаах
        </Button>

        <Button variant="danger" onClick={handleSave} disabled={saving}>
          {saving ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              />
              Хадгалж байна...
            </>
          ) : (
            "Хадгалах"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
